import { render, staticRenderFns } from "./TabelaFreteImportarForm.vue?vue&type=template&id=6e9a5cdf"
import script from "./TabelaFreteImportarForm.vue?vue&type=script&lang=js"
export * from "./TabelaFreteImportarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports